<template>
    <div class="switch-control">
        <div v-if="loading" class="loading-container">
            <div class="loading-text">正在加载设备状态...</div>
        </div>
        <div v-else-if="deviceList.length === 0" class="loading-container">
            <div class="loading-text">暂无控制设备</div>
        </div>
        <template v-else>
            <!-- 刷新按钮 -->
            <div class="refresh-bar">
                <button class="refresh-btn" :class="{ 'is-refreshing': isRefreshing }" @click="onRefreshStatus" :disabled="isRefreshing">
                    {{ isRefreshing ? '刷新中...' : '刷新状态' }}
                </button>
            </div>
            <!-- 动态渲染控制设备 -->
            <div class="switch-items-wrapper">
                <div v-for="(device, index) in deviceList" :key="device.id" class="switch-item">
                    <div class="switch-label">{{ device.deviceName }}</div>
                    <el-switch
                        v-model="deviceStatuses[device.deviceName]"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="handleChange(device, $event)">
                    </el-switch>
                    <div class="switch-status" :class="{ 'active': deviceStatuses[device.deviceName] }">
                        {{ deviceStatuses[device.deviceName] ? '开启' : '关闭' }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'DynamicControl',
        props: {
            pondsid: Number,
            companyId: Number,
            greenhouseId: Number
        },
    data() {
      return {
                loading: true,
                deviceList: [], // 从数据库加载的控制设备列表
                deviceStatuses: {}, // 设备状态映射
                isUpdatingFromServer: false,
                isLoading: false, // 请求锁，防止重复请求
                lastLoadParams: null, // 上次请求参数，用于比较
                isRefreshing: false // 刷新按钮状态
            }
    },
        methods: {
            updateWithDateRange(start, end) {
                // 开关控制不需要日期范围
            },
            setData() {
                // 必须有 greenhouseId 才发起请求
                if (!this.greenhouseId) {
                    console.log('dynamicControl: 没有有效的大棚ID，清空数据');
                    this.deviceList = [];
                    this.deviceStatuses = {};
                    this.loading = false;
                    return;
                }

                const currentParams = `${this.companyId}-${this.greenhouseId}`;
                console.log('dynamicControl setData() 被调用, currentParams:', currentParams, 'lastLoadParams:', this.lastLoadParams);

                // 如果参数没有变化，跳过请求
                if (this.lastLoadParams === currentParams && this.deviceList.length > 0) {
                    console.log('dynamicControl: 参数未变化，跳过请求');
                    return;
                }

                this.loading = true;
                this.loadControlDevices();
            },
            // 从数据库加载控制设备列表
            loadControlDevices() {
                const currentParams = `${this.companyId}-${this.greenhouseId}`;
                console.log('loadControlDevices() 被调用, currentParams:', currentParams);

                this.isLoading = true;

                const params = {};
                if (this.greenhouseId) {
                    params.greenhouseId = this.greenhouseId;
                } else if (this.companyId) {
                    params.companyId = this.companyId;
                }

                console.log('请求设备列表，参数:', params);

                this.request.get("/api/equipment/control/list", { params }).then(res => {
                    console.log('设备列表响应:', res);
                    if (res.code === "200" && res.data) {
                        this.deviceList = res.data || [];
                        console.log("加载控制设备列表:", this.deviceList);

                        // 重置状态对象
                        this.deviceStatuses = {};
                        // 初始化状态对象
                        this.deviceList.forEach(device => {
                            this.$set(this.deviceStatuses, device.deviceName, false);
                        });

                        // 记录本次请求参数
                        this.lastLoadParams = currentParams;

                        // 加载完设备后，读取状态
                        this.refreshDeviceStatus();
                    } else {
                        console.warn("获取控制设备列表失败:", res);
                        this.deviceList = [];
                        this.deviceStatuses = {};
                    }
                }).catch(error => {
                    console.error("获取控制设备列表失败:", error);
                    this.deviceList = [];
                    this.deviceStatuses = {};
                }).finally(() => {
                    this.loading = false;
                    this.isLoading = false;
                });
            },
            // 从MQTT读取设备状态
            refreshDeviceStatus() {
                this.isUpdatingFromServer = true;
                this.isRefreshing = true;

                const params = {};
                if (this.greenhouseId) {
                    params.greenhouseId = this.greenhouseId;
                } else if (this.companyId) {
                    params.companyId = this.companyId;
                }

                this.request.get("/api/equipment/status", { params }).then(res => {
                    console.log("设备状态响应:", res);
                    console.log("响应结构:", JSON.stringify(res));
                    // 检查 MQTT 错误标志 e:1 或空数据表示错误
                    // MQTT 原始格式: {"f":"qa","d":[...],"i":"in transmission mod","e":1}
                    // 后端返回: {"code":"200","message":"成功","data":{}} (空数据=失败)
                    const isDataEmpty = res && res.data && Object.keys(res.data).length === 0;
                    const hasError = res && (
                        res.e === 1 ||
                        res.code === 'error' ||
                        res.data?.e === 1 ||
                        res.data?.code === 'error' ||
                        (typeof res.i === 'string' && res.i.includes('transmission')) ||
                        isDataEmpty
                    );
                    if (hasError) {
                        console.error('MQTT 设备状态错误:', res.i || res.message || res.data?.i || '数据为空');
                        this.$message.error('刷新失败');
                        return;
                    }
                    if (res && res.data) {
                        const statusMap = typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : {};
                        Object.keys(statusMap).forEach(deviceName => {
                            if (deviceName in this.deviceStatuses) {
                                this.$set(this.deviceStatuses, deviceName, Boolean(statusMap[deviceName]));
                            }
                        });
                        console.log("设备状态已更新:", this.deviceStatuses);
                        this.$message.success('刷新成功');
                    }
                }).catch(error => {
                    console.error("刷新设备状态失败:", error);
                    this.$message.error('刷新失败');
                }).finally(() => {
                    this.isUpdatingFromServer = false;
                    this.isRefreshing = false;
                });
            },
            // 手动刷新按钮
            onRefreshStatus() {
                this.refreshDeviceStatus();
            },
            // 控制设备
            handleChange(device, value) {
                // 发送控制请求
                this.request.post("/api/equipment/control", {
                    greenhouseId: this.greenhouseId,
                    deviceKey: device.deviceName,
                    value: value ? "1" : "0"
                }).then(res => {
                    if (res.code === "200") {
                        this.$message.success(device.deviceName + (value ? '已开启' : '已关闭'));
                    } else {
                        const errorMsg = res.message || res.msg || '操作失败';
                        this.$message.error(errorMsg);
                        // 恢复原状态
                        this.$set(this.deviceStatuses, device.deviceName, !value);
                    }
                }).catch(error => {
                    console.error("控制设备失败:", error);
                    this.$message.error('操作失败: ' + (error.response?.data?.message || error.message || '网络错误'));
                    // 恢复原状态
                    this.$set(this.deviceStatuses, device.deviceName, !value);
                });
            }
        },
        mounted() {
            // 不再自动刷新，改为手动刷新
        },
        beforeDestroy() {
            // 清理工作
        },
        watch: {
            pondsid() {
                // 只有当有有效的 greenhouseId 时才刷新状态
                if (this.pondsid && this.pondsid === this.greenhouseId) {
                    this.refreshDeviceStatus();
                }
            },
            greenhouseId(newVal, oldVal) {
                // 无论 greenhouseId 如何变化，只要新值有效就重新加载
                if (newVal) {
                    console.log('dynamicControl: 检测到大棚变化，从', oldVal, '到', newVal, '，清空旧数据，准备加载新数据');
                    // 立即清空旧数据，显示loading
                    this.deviceList = [];
                    this.deviceStatuses = {};
                    this.loading = true;
                    this.isLoading = false; // 重置加载状态
                    this.lastLoadParams = null; // 重置参数记录
                    this.setData();
                }
            },
            companyId() {
                // companyId 变化时，只有当没有具体大棚ID时才重新请求
                if (this.companyId && !this.greenhouseId) {
                    this.setData();
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .switch-control {
        height: 100%;
        width: 100%;
        position: relative;
        padding: 45px 20px 20px;

        .loading-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .loading-text {
                color: #fff;
                font-size: 18px;
            }
        }

        .refresh-bar {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 10;

            .refresh-btn {
                padding: 6px 14px;
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.2);
                border-radius: 4px;
                color: #fff;
                font-size: 12px;
                cursor: pointer;
                transition: all 0.3s;
                white-space: nowrap;

                &:hover {
                    background: rgba(255, 255, 255, 0.2);
                }

                &.is-refreshing {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            }
        }

        .switch-items-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 15px;
            width: 100%;
        }

        .switch-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
            min-width: 80px;
            padding: 10px;

            .switch-label {
                color: #fff;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
            }

            .switch-status {
                color: #999;
                font-size: 12px;
                transition: color 0.3s;

                &.active {
                    color: #13ce66;
                }
            }
        }
    }
</style>
